<template>
  <div class="page">
    <div class="grid grid-one-column grid-align-top">
      <div class="page-heading">
        Manurewa Weather
      </div>
      <div class="bottom-widget weather-new-page">
        <div class="weather-day-item" v-for="item in forecast" v-bind:key="item.dt">
          <div class="forecast__day">
            {{ timestampToDay(item.dt) }}
          </div>
          <div class="forecast__icon">
            <img :src="`https://openweathermap.org/img/wn/${item.weather[0].icon}@2x.png`" alt="">
          </div>
          <div class="forecast__weather">{{ item.weather[0].description }}</div>
          <div class="forecast__high">Hi {{ item.temp.max }}°C / Lo {{ item.temp.min }}°C</div>
        </div>
      </div>
      <smart-block
        link="https://www.metservice.com/towns-cities/locations/auckland"
        icon="https://ucarecdn.com/958bc54a-a087-4e23-b603-411dc1502782/MetService.png"
        heading="Check Auckland Weather"
      />
      <smart-block
        link="/webcams"
        heading="Weather and Surf Cams"
      />
    </div>
  </div>
</template>

<script>
import {timestampToDay, getForecastByCoordinates} from "../assets/scripts/services";
import {getCache, setCache} from "../assets/scripts/cache";
import SmartBlock from "../components/SmartBlock.vue";

export default {
  name: "Weather",
  components: {
    SmartBlock
  },
  data() {
    return {
      forecast: []
    }
  },
  async mounted() {
    // Weather
    const cache = getCache('forecast');
    if (cache !== null) {
      this.forecast = cache;
    }
    else {
      this.forecast = await this.getMtEdenForecast();
      setCache('forecast', this.forecast, 10);
    }

    // Update weather every 10 minutes
    setTimeout(() => {
      this.getMtEdenForecast();
    }, 600000);
  },
  methods: {
    async getMtEdenForecast() {
      return await getForecastByCoordinates({lat: -36.8871, lon: 174.7474});
    },
    timestampToDay(timestamp) {
      return timestampToDay(timestamp);
    }
  }
}
</script>

<style scoped>
.weather-new-page {
  background-color: #3c7dbd;
  border-radius: 10px;
  box-shadow: 0 1rem 1rem rgb(0 0 0 / 20%);
  border: 1px solid rgba(255, 255, 255, 0.4);
  background-image: linear-gradient(15deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.2));
  padding: clamp(20px, 3vw, 20px)
}
.grid {
  display: grid;
  grid-gap: clamp(20px, 3vw, 20px);
  box-sizing: border-box;
  flex: 1;
}

.grid-two-column {
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
}

.grid-align-top {
  grid-auto-rows: max-content;
}

.grid-one-column {
  grid-template-columns: 1fr;
  grid-auto-rows: max-content;
}
</style>
